import ComboBox from "./ComboBox";
import { ComboListProps } from "../models/PropsInterface";
import "../cssStyles/ComboList.css";

const ComboList = (props: ComboListProps) => {
  return (
    <>
      <div
        className={`vas-row combo-list_container ${
          props.language == "ar"
            ? "combo-list_container_rtl"
            : "combo-list_container_ltr"
        } `}
      >
        {props.packages.map((comboPackage) => {
          return (
            <ComboBox
              setIsSuccessProcess={props.setIsSuccessProcess}
              referral_url={props.referral_url}
              countryAbbreviation={props.countryAbbreviation}
              {...comboPackage}
              api={props.api}
              source={props.source}
              modelId={props.modelId}
              token={props.token}
              language={props.language}
            />
          );
        })}
      </div>
    </>
  );
};

export default ComboList;
